import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const StudentProfileCard = ({ student }) => {
  const mockDetailedProfile = {
    ...student,
    academicHistory: [
      { semester: 'Semestre 1 2025-2026', average: 14.5, rank: 12 },
      { semester: 'Semestre 2 2024-2025', average: 13.8, rank: 15 }
    ],
    quizPerformance: [
      { title: 'Sciences de l\'Ingénieur', score: 92, date: '2026-02-10' },
      { title: 'Économie et Gestion', score: 88, date: '2026-02-08' },
      { title: 'Sciences de la Santé', score: 85, date: '2026-02-05' }
    ],
    fieldExploration: [
      { field: 'Ingénierie', progress: 78, timeSpent: '4h 30min' },
      { field: 'Sciences', progress: 65, timeSpent: '3h 15min' },
      { field: 'Technologies', progress: 52, timeSpent: '2h 45min' }
    ],
    interventionTimeline: [
      { date: '2026-02-09', type: 'note', content: 'Session individuelle - Discussion sur objectifs de carrière', counselor: 'M. Diop' },
      { date: '2026-02-01', type: 'alert', content: 'Recommandation: Renforcer les compétences en mathématiques', counselor: 'Système' },
      { date: '2026-01-25', type: 'meeting', content: 'Réunion parents-conseiller - Suivi académique', counselor: 'M. Diop' }
    ],
    parentCommunicationHistory: [
      { date: '2026-02-10', type: 'email', subject: 'Rapport de progression mensuel', status: 'sent' },
      { date: '2026-02-05', type: 'call', subject: 'Discussion sur résultats quiz', status: 'completed' },
      { date: '2026-01-28', type: 'message', subject: 'Invitation réunion de suivi', status: 'read' }
    ]
  };

  return (
    <div className="space-y-6">
      {/* Header Card */}
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center text-white text-xl font-semibold">
            {student?.name?.split(' ')?.map(n => n?.[0])?.join('')}
          </div>
          <div className="flex-1">
            <h2 className="text-2xl font-bold text-gray-900 mb-1">{student?.name}</h2>
            <p className="text-gray-600 mb-2">{student?.grade}</p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-blue-100 text-blue-700 text-sm rounded-full">
                Performance: {student?.performanceScore}%
              </span>
              <span className="px-3 py-1 bg-green-100 text-green-700 text-sm rounded-full">
                Précision IA: {student?.recommendationAccuracy}%
              </span>
              <span className="px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full">
                Quiz: {student?.quizCompletion}/15
              </span>
            </div>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" iconName="Mail">
              Contacter
            </Button>
            <Button variant="default" size="sm" iconName="Calendar">
              Planifier
            </Button>
          </div>
        </div>
      </div>

      {/* Academic History */}
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <Icon name="BookOpen" size={20} />
          Historique Académique
        </h3>
        <div className="space-y-3">
          {mockDetailedProfile?.academicHistory?.map((record, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div>
                <p className="font-medium text-gray-900">{record?.semester}</p>
                <p className="text-sm text-gray-600">Rang: {record?.rank}/30</p>
              </div>
              <div className="text-right">
                <p className="text-xl font-bold text-blue-600">{record?.average}</p>
                <p className="text-xs text-gray-600">Moyenne</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quiz Performance */}
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <Icon name="ClipboardCheck" size={20} />
          Performance Quiz Récents
        </h3>
        <div className="space-y-3">
          {mockDetailedProfile?.quizPerformance?.map((quiz, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div className="flex-1">
                <p className="font-medium text-gray-900">{quiz?.title}</p>
                <p className="text-sm text-gray-600">{new Date(quiz?.date)?.toLocaleDateString('fr-FR')}</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-24 bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-blue-500 h-2 rounded-full"
                    style={{ width: `${quiz?.score}%` }}
                  />
                </div>
                <span className="text-lg font-bold text-gray-900 w-12 text-right">{quiz?.score}%</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Field Exploration Progress */}
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <Icon name="Compass" size={20} />
          Progression Exploration de Domaines
        </h3>
        <div className="space-y-4">
          {mockDetailedProfile?.fieldExploration?.map((field, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <span className="font-medium text-gray-900">{field?.field}</span>
                <span className="text-sm text-gray-600">{field?.timeSpent}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-green-500 h-2 rounded-full"
                  style={{ width: `${field?.progress}%` }}
                />
              </div>
              <p className="text-xs text-gray-600 mt-1">{field?.progress}% complété</p>
            </div>
          ))}
        </div>
      </div>

      {/* Intervention Timeline */}
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <Icon name="Activity" size={20} />
          Chronologie des Interventions
        </h3>
        <div className="space-y-4">
          {mockDetailedProfile?.interventionTimeline?.map((event, index) => {
            const iconMap = {
              note: { name: 'FileText', color: '#3b82f6' },
              alert: { name: 'AlertTriangle', color: '#f59e0b' },
              meeting: { name: 'Users', color: '#10b981' }
            };
            const icon = iconMap?.[event?.type];
            
            return (
              <div key={index} className="flex gap-3">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                  <Icon name={icon?.name} size={16} color={icon?.color} />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-900">{event?.content}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <p className="text-xs text-gray-600">{new Date(event?.date)?.toLocaleDateString('fr-FR')}</p>
                    <span className="text-xs text-gray-400">•</span>
                    <p className="text-xs text-gray-600">{event?.counselor}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Parent Communication History */}
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <Icon name="MessageCircle" size={20} />
          Historique Communication Parents
        </h3>
        <div className="space-y-3">
          {mockDetailedProfile?.parentCommunicationHistory?.map((comm, index) => {
            const typeIcons = {
              email: 'Mail',
              call: 'Phone',
              message: 'MessageSquare'
            };
            
            return (
              <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-3">
                  <Icon name={typeIcons?.[comm?.type]} size={18} color="#6b7280" />
                  <div>
                    <p className="font-medium text-gray-900">{comm?.subject}</p>
                    <p className="text-sm text-gray-600">{new Date(comm?.date)?.toLocaleDateString('fr-FR')}</p>
                  </div>
                </div>
                <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded capitalize">
                  {comm?.status}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StudentProfileCard;